import { Layout, Row, Col, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import { LEGAL_COPY } from '@rescue-foodies/shared-types';

const { Footer } = Layout;
const { Title, Text } = Typography;

export const AppFooter = () => {
  const currentYear = new Date().getFullYear();

  // Environment variable validation with developer-friendly warning
  const merchantDashboardUrl = import.meta.env.VITE_MERCHANT_DASHBOARD_URL;

  if (!merchantDashboardUrl && import.meta.env.DEV) {
    console.warn(
      '⚠️ VITE_MERCHANT_DASHBOARD_URL is not set. Using fallback: business.rescuefoodies.com\n' +
      'Add VITE_MERCHANT_DASHBOARD_URL to your .env file for proper configuration.'
    );
  }

  const finalMerchantUrl = merchantDashboardUrl || 'business.rescuefoodies.com';

  return (
    <Footer
      style={{
        background: '#001529',
        color: '#ffffff',
        marginTop: 'auto',
        padding: '48px 24px 24px',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        {/* Merchant CTA Section */}
        <div style={{ marginBottom: 48, padding: '32px 24px', background: 'rgba(255, 255, 255, 0.05)', borderRadius: 8 }}>
          <Title level={4} style={{ color: '#ffffff', marginBottom: 16, textAlign: 'center' }}>
            Are you a restaurant owner?
          </Title>
          <div style={{ textAlign: 'center' }}>
            <a
              href={`https://${finalMerchantUrl}/register`}
              style={{ textDecoration: 'none' }}
            >
              <Button
                type="primary"
                size="large"
                style={{
                  background: '#F5A623',
                  border: 'none',
                  height: 'auto',
                  minHeight: 56,
                  minWidth: 240,
                  maxWidth: 'calc(100vw - 96px)',
                  width: '100%',
                  fontSize: 16,
                  fontWeight: 600,
                  padding: '16px 24px',
                  whiteSpace: 'normal',
                  lineHeight: 1.4,
                }}
              >
                Join Rescue Foodies as a merchant
              </Button>
            </a>
          </div>
        </div>
        <Row gutter={[32, 32]}>
          {/* Company Section */}
          <Col xs={24} sm={12} md={6}>
            <Title level={5} style={{ color: '#ffffff', marginBottom: 16 }}>
              Company
            </Title>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Link to="/about" style={{ color: 'rgba(255,255,255,0.7)' }}>
                About Us
              </Link>
              <Link to="/how-it-works" style={{ color: 'rgba(255,255,255,0.7)' }}>
                How It Works
              </Link>
              <Link to="/for-businesses" style={{ color: 'rgba(255,255,255,0.7)' }}>
                For Businesses
              </Link>
              <a
                href="https://blog.rescuefoodies.ph"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgba(255,255,255,0.7)' }}
              >
                Blog
              </a>
            </div>
          </Col>

          {/* Support Section */}
          <Col xs={24} sm={12} md={6}>
            <Title level={5} style={{ color: '#ffffff', marginBottom: 16 }}>
              Support
            </Title>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Link to="/contact" style={{ color: 'rgba(255,255,255,0.7)' }}>
                Contact Us
              </Link>
              <a
                href="mailto:rescuefoodies@gmail.com"
                style={{ color: 'rgba(255,255,255,0.7)' }}
              >
                rescuefoodies@gmail.com
              </a>
              <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14 }}>
                Help Center (coming soon)
              </Text>
            </div>
          </Col>

          {/* Legal Section */}
          <Col xs={24} sm={12} md={6}>
            <Title level={5} style={{ color: '#ffffff', marginBottom: 16 }}>
              Legal
            </Title>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Link to="/terms" style={{ color: 'rgba(255,255,255,0.7)' }}>
                Terms and Conditions
              </Link>
              <Link to="/privacy" style={{ color: 'rgba(255,255,255,0.7)' }}>
                Privacy Policy
              </Link>
              <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14 }}>
                Cancellations & Refunds (coming soon)
              </Text>
            </div>
          </Col>

          {/* Social Section */}
          <Col xs={24} sm={12} md={6}>
            <Title level={5} style={{ color: '#ffffff', marginBottom: 16 }}>
              Connect
            </Title>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <a
                href="https://www.facebook.com/profile.php?id=61584898442916"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgba(255,255,255,0.7)' }}
              >
                Facebook
              </a>
              <a
                href="https://www.instagram.com/rescuefoodies/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgba(255,255,255,0.7)' }}
              >
                Instagram
              </a>
              <a
                href="https://twitter.com/rescuefoodies"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgba(255,255,255,0.7)' }}
              >
                Twitter
              </a>
            </div>
          </Col>
        </Row>

        {/* Marketplace Notice */}
        <div
          style={{
            marginTop: 32,
            paddingTop: 24,
            borderTop: '1px solid rgba(255,255,255,0.1)',
          }}
        >
          <Text style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, display: 'block' }}>
            {LEGAL_COPY.footer.marketplaceNotice}
          </Text>
        </div>

        {/* Copyright */}
        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <Text style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12 }}>
            {LEGAL_COPY.footer.copyright(currentYear)}
          </Text>
        </div>
      </div>
    </Footer>
  );
};
